/* GENERATED by scripts/gen-data.mjs — film scene "f-split" (from s1.js + s2.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

import type { FilmScene } from '../../types';

export const F_SPLIT: FilmScene = {
  "w": 640,
  "h": 300,
  "items": [
    {
      "k": "frame",
      "id": "fr",
      "x": 14,
      "y": 14,
      "w": 612,
      "h": 272,
      "lKey": "films:f-split.items.fr.l"
    },
    {
      "k": "box",
      "id": "r1",
      "x": 28,
      "y": 48,
      "w": 212,
      "h": 52,
      "lKey": "films:f-split.items.r1.l",
      "sKey": "films:f-split.items.r1.s"
    },
    {
      "k": "chip",
      "id": "e1",
      "x": 462,
      "y": 58,
      "w": 150,
      "h": 32,
      "lKey": "films:f-split.items.e1.l"
    },
    {
      "k": "wire",
      "id": "w1",
      "from": "r1",
      "to": "e1",
      "dash": true
    },
    {
      "k": "box",
      "id": "r2",
      "x": 28,
      "y": 124,
      "w": 212,
      "h": 52,
      "lKey": "films:f-split.items.r2.l",
      "sKey": "films:f-split.items.r2.s"
    },
    {
      "k": "chip",
      "id": "e2",
      "x": 462,
      "y": 134,
      "w": 150,
      "h": 32,
      "lKey": "films:f-split.items.e2.l"
    },
    {
      "k": "wire",
      "id": "w2",
      "from": "r2",
      "to": "e2",
      "dash": true
    },
    {
      "k": "box",
      "id": "r3",
      "x": 28,
      "y": 200,
      "w": 212,
      "h": 52,
      "lKey": "films:f-split.items.r3.l",
      "sKey": "films:f-split.items.r3.s"
    },
    {
      "k": "chip",
      "id": "e3",
      "x": 462,
      "y": 210,
      "w": 150,
      "h": 32,
      "lKey": "films:f-split.items.e3.l"
    },
    {
      "k": "wire",
      "id": "w3",
      "from": "r3",
      "to": "e3",
      "dash": true
    },
    {
      "k": "note",
      "id": "n1",
      "x": 256,
      "y": 262,
      "lKey": "films:f-split.items.n1.l"
    }
  ],
  "steps": [
    {
      "on": [
        "fr",
        "r1",
        "e1",
        "w1"
      ],
      "hot": [
        "r1",
        "e1"
      ],
      "capKey": "films:f-split.steps.0.cap"
    },
    {
      "on": [
        "fr",
        "r1",
        "e1",
        "w1",
        "r2",
        "e2",
        "w2"
      ],
      "hot": [
        "r2",
        "e2"
      ],
      "capKey": "films:f-split.steps.1.cap"
    },
    {
      "on": [
        "fr",
        "r1",
        "e1",
        "w1",
        "r2",
        "e2",
        "w2",
        "r3",
        "e3",
        "w3"
      ],
      "hot": [
        "r3",
        "e3"
      ],
      "capKey": "films:f-split.steps.2.cap"
    },
    {
      "on": [
        "fr",
        "r1",
        "e1",
        "w1",
        "r2",
        "e2",
        "w2",
        "r3",
        "e3",
        "w3",
        "n1"
      ],
      "hot": [
        "n1"
      ],
      "capKey": "films:f-split.steps.3.cap"
    }
  ]
};
